__turbopack_context__.v({
  "header": "qjilNq_header",
  "header--large": "qjilNq_header--large",
  "header--small": "qjilNq_header--small",
});
